import { BaseHttpError } from './error';

export class ServerError extends BaseHttpError {
  constructor(...params) {
    super(...params);
    this.name = ServerError.getName();
  }

  static getName() {
    return 'ServerError';
  }
}
